import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/user/')({
  loader: async () => {
    throw redirect({ to: '/user/account' });
  },
});
